import React from "react";

const FourPlyNotes = ({
  fontSize = 12,
  fontWeight = "bold",
  marginTop = 24,
  lineHeight = 1.6,
}) => (
  <div
    style={{
      fontSize,
      fontWeight,
      textAlign: "left",
      marginTop,
      lineHeight,
    }}
  >
    <p style={{ marginBottom: 4 }}>
      <b>Catatan:</b>
    </p>
    <p style={{ marginBottom: 2 }}>1. Lembar warna Putih untuk Pengirim</p>
    <p style={{ marginBottom: 2 }}>2. Lembar warna Merah untuk Penerima</p>
    <p style={{ marginBottom: 2 }}>3. Lembar warna Kuning untuk Arsip</p>
    <p style={{ marginBottom: 0 }}>4. Lembar warna Biru untuk Security</p>
  </div>
);

export default FourPlyNotes;
